import { useEffectOnce } from 'react-use';
import { Loader } from 'components/Loader';
import { withScreenerMachineState } from 'domains/signup/screener/context/screenerContext';
import { routes } from 'router/routes';
import { useNavigation } from 'utils/hooks/useNavigation';
import { useLDClient } from 'launchdarkly-react-client-sdk';
import { SIGNUP_LAUNCHDARKLY_EVENTS } from 'domains/signupDirect/misc/launchDarklyTracking';

const Finished: React.FC = () => {
  const { navigate } = useNavigation();

  const LDClient = useLDClient();

  useEffectOnce(() => {
    LDClient?.track(SIGNUP_LAUNCHDARKLY_EVENTS.SCREENER_PROGRESS.COMPLETED);

    // @HACK:FIXME:(juan): find a way of doing this from the machine, this is a workaround
    navigate(routes.screener.results.base);
  });
  return (
    <>
      <Loader className="flex justify-center p-24 text-primary-500" />
    </>
  );
};

export const ScreenerFinished = withScreenerMachineState(Finished, 'finished');
